import React from 'react'

export const MapContext = React.createContext()
